const removeAnnouncement = $ele => {
  //
  // TODO: get this parent dynamically...
  //
  Kadenze.Ajax.delete({
    $element: $ele,
    $parent: $ele.parent().parent().parent(),
  })
}

export default {
  init: element => {
    $('.action-btn--delete').click(evt => {
      Kadenze.UIUtil.confirmAction(
        I18n.t('announcements.delete.confirm'),
        () => removeAnnouncement($(evt.target))
      )
      return false
    })
  }
}
